type Rotate3dTransform = [number, number, number];

type MapRangeProps = {
  value: number;
  x1: number;
  y1: number;
  x2: number;
  y2: number;
};

export const mapRange = ({ value, x1, y1, x2, y2 }: MapRangeProps) =>
  ((value - x1) * (y2 - x2)) / (y1 - x1) + x2;

export const rotate = (degree: number, amount: number) => {
  const result = degree + amount;
  return result > 360 ? result - 360 : result;
};

export const coinFlip = () => Math.random() > 0.5;

// avoid this for circles, as it will have no visual effect
const zAxisRotation: Rotate3dTransform = [0, 0, 1];

export const rotationTransforms: Rotate3dTransform[] = [
  // dual axis rotations (a bit more realistic)
  [1, 1, 0],
  [1, 0, 1],
  [0, 1, 1],
  // single axis rotations (a bit dumber)
  [1, 0, 0],
  [0, 1, 0],
  zAxisRotation,
];

const arraysEqual = (a: number[], b: number[]) => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

export const shouldBeCircle = (rotationIndex: number) => {
  return !arraysEqual(rotationTransforms[rotationIndex], zAxisRotation) && coinFlip();
};
